import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";

// 게스트 전용 폼들
import GuestBasicForm from "./GuestBasicForm";
import GuestDescriptionForm from "./GuestDescriptionForm";
import GuestFileUploadForm from "./GuestFileUploadForm";

function EditSpaceFeed() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  console.log("PAGE TOKEN =", window.location.search);
  console.log("READ TOKEN FROM SEARCHPARAMS =", token);

  const [loading, setLoading] = useState(true);
  const [feed, setFeed] = useState(null);
  const [details, setDetails] = useState(null);
  const [images, setImages] = useState([]);
  const [error, setError] = useState(null);

  // 기존 데이터 불러오기
  const loadFeed = () => {
    console.log("API CALL TOKEN =", token);
    axios
      .get(`/api/space-feed/edit?token=${token}`)
      .then((res) => {
        setFeed(res.data.propertyBasic);
        setDetails(res.data.propertyDetails);
        setImages(res.data.media);
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to load posting");
        setLoading(false);
      });
  };

  useEffect(() => {
    console.log("USE EFFECT TOKEN =", token);
    if (!token) {
      setError("Invalid edit link");
      setLoading(false);
      return;
    }
    loadFeed();
  }, [token]);

  // 저장 버튼
  const handleSave = () => {
     // createdDate 제거 (백엔드에서 LocalDateTime 역직렬화 에러 방지)
    const cleanBasic = { ...feed };
    delete cleanBasic.createdDate;
    const payload = {
      propertyBasic: cleanBasic,
      propertyDetails: details,
    };

    axios
      .put(`/api/space-feed/edit?token=${token}`, payload)
      .then(() => {
        alert("Your posting has been updated!");
        navigate(`/property-detail/${feed.spaceFeedId}`);
      })
      .catch(() => {
        alert("Failed to update posting");
      });
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div style={{ color: "red" }}>{error}</div>;

  return (
    <div className="container">
      <h1 className="mt-4 mb-4">Edit Your Posting</h1>

      {/* Basic Info */}
      <GuestBasicForm feed={feed} setFeed={setFeed} />

      {/* Description */}
      <GuestDescriptionForm details={details} setDetails={setDetails} />

      {/* Images */}
      <GuestFileUploadForm
        images={images}
        setImages={setImages}
        token={token}
        reload={loadFeed}
      />

      <div className="d-flex justify-content-end mt-4 mb-5">
        <button className="primary-btn" onClick={handleSave}>
          Save Changes
        </button>
      </div>
    </div>
  );
}

export default EditSpaceFeed;